<template>
<div v-show="is_show" class="splash ">
  <span class="loader"></span>
  <br>
  <br>
  <h2>ویدا پارت</h2>
</div>
</template>

<script>
export default {
  name: "Splash",
  data(){
    return{
      is_show: true
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
h2{
  font-size: 1.4vw;
  display: none;
}
.splash{
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.7);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

}
.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid #FFF;
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border-left: 4px solid #0077ff;
  border-bottom: 4px solid transparent;
  animation: rotation 0.5s linear infinite reverse;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>